"use strict";
// Shows a 12-word recovery phrase with a double confirmation: the phrase must be downloaded or
// copied, then "I saved it" checked, then the button waits a few seconds before it can be used.
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var classnames_1 = __importDefault(require("classnames"));
var components_1 = require("stremio/components");
var components_2 = require("stremio/routes/Settings/components");
var ProfileGate_less_1 = __importDefault(require("./ProfileGate.less"));
var CONFIRM_DELAY = 5;
var recoveryFile = function (phrase, profileName, t) {
    var words = phrase.split(' ').map(function (word, index) { return "".concat(String(index + 1).padStart(2, ' '), ". ").concat(word); }).join('\n');
    return [
        t('PLUS_RECOVERY_FILE_TITLE'),
        "".concat(t('PLUS_RECOVERY_FILE_PROFILE'), " ").concat(profileName),
        "".concat(t('PLUS_RECOVERY_FILE_DATE'), " ").concat(new Date().toLocaleString()),
        '',
        words,
        '',
        t('PLUS_RECOVERY_FILE_WARNING'),
        '',
    ].join('\n');
};
var RecoveryPhrase = function (_a) {
    var phrase = _a.phrase, profileName = _a.profileName, onDone = _a.onDone;
    var t = (0, react_i18next_1.useTranslation)().t;
    var _b = (0, react_1.useState)(false), saved = _b[0], setSaved = _b[1];
    var _c = (0, react_1.useState)(false), confirmed = _c[0], setConfirmed = _c[1];
    var _d = (0, react_1.useState)(CONFIRM_DELAY), countdown = _d[0], setCountdown = _d[1];
    var _e = (0, react_1.useState)(false), copied = _e[0], setCopied = _e[1];
    // The countdown only starts once the box is checked, and restarts if it is unchecked.
    (0, react_1.useEffect)(function () {
        if (!confirmed) {
            setCountdown(CONFIRM_DELAY);
            return;
        }
        if (countdown === 0)
            return;
        var timeout = setTimeout(function () { return setCountdown(countdown - 1); }, 1000);
        return function () { return clearTimeout(timeout); };
    }, [confirmed, countdown]);
    var download = (0, react_1.useCallback)(function () {
        var blob = new Blob([recoveryFile(phrase, profileName, t)], { type: 'text/plain;charset=utf-8' });
        var url = URL.createObjectURL(blob);
        var link = document.createElement('a');
        link.href = url;
        link.download = "stremio-plus-recovery-".concat(profileName.replace(/[^\w-]+/g, '_'), ".txt");
        link.click();
        setTimeout(function () { return URL.revokeObjectURL(url); }, 1000);
        setSaved(true);
    }, [phrase, profileName, t]);
    var copy = (0, react_1.useCallback)(function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, navigator.clipboard.writeText(phrase)];
                case 1:
                    _a.sent();
                    setCopied(true);
                    setSaved(true);
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    console.error('Stremio Plus:', error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); }, [phrase]);
    return (react_1.default.createElement("div", { className: ProfileGate_less_1.default['editor'] },
        react_1.default.createElement("div", { className: ProfileGate_less_1.default['title'] }, t('PLUS_RECOVERY_TITLE')),
        react_1.default.createElement(components_2.Section, null,
            react_1.default.createElement("div", { className: ProfileGate_less_1.default['hint'] }, t('PLUS_RECOVERY_TEXT', { name: profileName })),
            react_1.default.createElement("ol", { className: ProfileGate_less_1.default['recovery-words'] }, phrase.split(' ').map(function (word, index) { return react_1.default.createElement("li", { key: index }, word); })),
            react_1.default.createElement("div", { className: ProfileGate_less_1.default['avatar-actions'] },
                react_1.default.createElement(components_1.Button, { className: (0, classnames_1.default)(ProfileGate_less_1.default['button'], ProfileGate_less_1.default['shuffle']), onClick: download }, t('PLUS_RECOVERY_DOWNLOAD')),
                react_1.default.createElement(components_1.Button, { className: (0, classnames_1.default)(ProfileGate_less_1.default['button'], ProfileGate_less_1.default['shuffle']), onClick: copy }, copied ? t('PLUS_RECOVERY_COPIED') : t('PLUS_RECOVERY_COPY'))),
            react_1.default.createElement("div", { className: ProfileGate_less_1.default['warning'] }, t('PLUS_RECOVERY_WARNING')),
            react_1.default.createElement(components_1.Checkbox, { name: 'recovery-saved', className: ProfileGate_less_1.default['checkbox'], label: t('PLUS_RECOVERY_CONFIRM'), disabled: !saved, checked: confirmed, onChange: function (_a) {
                    var checked = _a.checked;
                    return setConfirmed(checked);
                } })),
        react_1.default.createElement("div", { className: ProfileGate_less_1.default['actions'] },
            react_1.default.createElement(components_1.Button, { className: (0, classnames_1.default)(ProfileGate_less_1.default['button'], ProfileGate_less_1.default['primary']), disabled: !confirmed || countdown > 0, onClick: onDone }, countdown > 0 && confirmed ? "".concat(t('PLUS_RECOVERY_DONE'), " (").concat(countdown, ")") : t('PLUS_RECOVERY_DONE')))));
};
exports.default = RecoveryPhrase;
